<template>
	<div>
		<div v-if="authUser.meli_user_id">
			<p>
				<vs-button color="" type="border" @click="popUpchangeMeliAuth" size="small"
					 class="text-primary rounded my-2" 
					 icon="keyboard_arrow_right" icon-after>
						Cambiar a otra cuenta de Mercadolibre
				</vs-button>
				<vs-popup :active.sync="popupActive" title="Cambiar tu cuenta de Mercadolibre">
					<div class="bg-warning rounded p-3 text-white" >
						<strong>Consideraciones Importantes:</strong>
						<ul class="pt-2">
						 <li class="py-1">- Debés iniciar sesión previamente en la nueva cuenta de Mercadolibre que querés conectar.</li>
						 <li class="py-1">- No recibirás actualizaciones ni podrás procesar las órdenes asociadas a la cuenta actual de Mercadolibre.</li>
						</ul>
					</div>
					<div class="text-right">
						<vs-button color="" type="border" @click="doChangeMeliAuthorizationAccount" size="small"
						 class="text-primary rounded my-2" style="float: right"
						 icon="keyboard_arrow_right" icon-after>
							Aceptar y Continuar
						</vs-button>
					</div>
				</vs-popup>
			</p>
		</div>		
		<div v-else >
			<vs-button color="#fff159" type="filled" @click="goToMeliAuthorization"
			 class="text-primary rounded my-2" 
			 icon="keyboard_arrow_right" icon-after>
				Conectar mi cuenta de Mercadolibre
			</vs-button>
		</div>
	</div>
</template>
<script>
	
	export default {
		name: 'MeliAccount',

		data(){
			return {
				popupActive:false
			}
		},

		methods: {
			goToMeliAuthorization(){
				window.location = 'https://auth.mercadolibre.com.ar/authorization?response_type=code&client_id='+this.meliAPIClientID + '&redirect_uri=' + this.meliAPIRedirect;
			},
			popUpchangeMeliAuth(){
				this.popupActive = true 
			},
			doChangeMeliAuthorizationAccount(){
				this.$vs.loading();
				// Llamada ajax a endpoint que borra el user->meli_id? o lo hago solo al regresar?				
				window.location = 'https://auth.mercadolibre.com.ar/authorization?response_type=code&client_id='+this.meliAPIClientID + '&redirect_uri=' + this.meliAPIRedirect;
			}
		},

		computed: {
			meliAPIClientID() {
				return process.env.VUE_APP_MELI_APP_ID
			},
			meliAPIClientSecret() {
				return process.env.VUE_APP_MELI_APP_SECRET
			},
			meliAPIRedirect() {
				return process.env.VUE_APP_MELI_REDIRECT
			},
			/*meliOauthRedirectURL(){
				return process.env.MIX_MELI_OAUTH_REDIRECT_URL
			},*/
			authUser(){
				return this.$store.state.authUser
			}
		}
	}

</script>